import script from "./FilePreviewXlsx.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilePreviewXlsx.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
